import Vue from 'vue'
import Vuex from 'vuex'
import { initLoginInfo } from '../api/index'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    accountName: '',
    forbiddenAccess: '',
    username: '',
    customerList: [],
    customerNameList: [],
    faceList: [],
    processesList: [],
    departmentList: [],
    operatorList: [],
    supplierList: [],
    productNameList: [],
    productSizeList: [],
    materialNameList: [],
    materialSizeList: [],
    tabList: [],
    pageLoading: false,
    firstInto: true
  },
  mutations: {
    doChangeLoginInfo (state, loginInfo) {
      state.customerList = loginInfo.customerList
      state.accountName = loginInfo.accountName
      state.forbiddenAccess = loginInfo.access
      state.username = loginInfo.username
      state.customerNameList = loginInfo.customerNameList
      state.faceList = loginInfo.faceList
      state.processesList = loginInfo.processesList.map(item => {
        const processInfo = item.split(':')
        return {
          name: processInfo[0],
          price: processInfo[1]
        }
      })
      state.departmentList = loginInfo.departmentList
      state.operatorList = loginInfo.operatorList
      state.supplierList = loginInfo.supplierList
      state.productNameList = loginInfo.productNameList
      state.productSizeList = loginInfo.productSizeList
      state.materialNameList = loginInfo.materialNameList
      state.materialSizeList = loginInfo.materialSizeList
      let productListSort = JSON.parse(localStorage.getItem('productListSort')) || {}
      state.productNameList.sort((a, b) => {
        let countA = productListSort[a] || 0
        let countB = productListSort[b] || 0
        return countB - countA
      })
      let tabList = [
        {
          icon: 'el-icon-date',
          index: '/home/index',
          title: '首 页'
        },
        {
          icon: 'el-icon-menu',
          index: '/home/productList',
          title: '产品列表'
        },
        // {
        //   icon: 'el-icon-tickets',
        //   index: '/home/customerOrderList',
        //   title: '客户订单'
        // },
        {
          icon: 'el-icon-document',
          index: '/home/produceList',
          title: '生产派工单'
        },
        {
          icon: 'el-icon-s-flag',
          index: '/home/produceReportList',
          title: '生产日报单'
        },
        {
          icon: 'el-icon-brush',
          index: '/home/materialList',
          title: '原料列表'
        },
        {
          icon: 'el-icon-goods',
          index: '/home/buyList',
          title: '原料采购单'
        },
        {
          icon: 'el-icon-setting',
          index: '/home/setting',
          title: '设 置'
        }
      ]
      if (loginInfo.username === 'xmly' || loginInfo.access.indexOf('1') === -1) {
        tabList.push({
          icon: 'el-icon-user',
          index: '/home/accountList',
          title: '账号管理'
        })
      }
      state.tabList = tabList
    },
    doChangeLoading (state) {
      state.pageLoading = false
      if (state.firstInto) {
        state.firstInto = false
        state.pageLoading = true
      }
    }
  },
  actions: {
    getLoginInfo (context) {
      context.commit('doChangeLoading')
      initLoginInfo().then(res => {
        if (res.data.status === 200) {
          context.commit('doChangeLoginInfo', res.data.data)
          context.commit('doChangeLoading')
        } else {
          this._vm.$message.error(res.data.msg)
        }
      })
    }
  }
})
export default store
